import * as React from 'react';
import Project from 'src/entities/Project';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import MyProjectCardComponent from 'src/modules/projects/my-projects/partials/MyProjectCard.component';

export interface Props {
  projects: Project[];
}

class MyProjectsListComponent extends React.PureComponent<Props> {

  public render(): React.ReactNode {

    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <h1 className="bold-title">
                Mi Empresa
              </h1>
              <div className="gap-20"/>
            </div>
            <div className="col-md-4">
              <p className="breadcrumb text-right">
                Inicio > Mi empresa
              </p>
            </div>
          </div>
          {this.props.projects.map(
            (project, key) => (
              <div key={key}>
                <MyProjectCardComponent
                  project={project}
                />
              </div>
            )
          )}
        </div>
      </section>
    );
  }
}

export default MyProjectsListComponent;



// WEBPACK FOOTER //
// ./src/modules/projects/my-projects/MyProjectsList.component.tsx